import styled from 'styled-components';

export const AddSelectMLStyled = styled.div`
  .ant-form-item {
    /* 为了居中公共没有margin，如果需要多个margin另加className */
    /* margin-bottom: 0px; */
  }
  .ant-form-item-label {
    text-align: left;
    width: 169px;
    font-size: 16px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border: 1px solid #d9d9d9;
    border-right: 0;
    background: #edf0f0;
    height: 47px;
    color: ${(props) => props.theme[props.brand].input.color};
  }
  .ant-form-item-no-colon {
    margin-top: 8px;
    background: #edf0f0;
    font-size: 16px;
    border-radius: 0px;
    padding: 0 11px;
  }
  .ant-form-item-control {
    * {
      border-radius: 0px;
    }
    .ant-select-selector {
      height: ${(props) => props.height} !important;
      border-radius: 0px;
    }
    .ant-select-arrow {
      top: 8px;
    }
    input {
      height: ${(props) => props.height} !important;
    }
  }
  .ant-select-selection-search-input {
    min-width: ${(props) => props.inputWidth};
    height: ${(props) => props.height};
    text-align: center;
    background: ${(props) => props.theme[props.brand].formSelect.selectBg};
    color: ${(props) => props.theme[props.brand].formSelect.singSelectColor};
    font-size: 16px;
    border-radius: 0px;
    border-color: ${(props) => props.theme[props.brand].formSelect.selectColor};
  }
  .ant-select:hover {
    .ant-select-selector {
      border-color: ${(props) =>
        props.theme[props.brand].formSelect.addSingSelectBdNew} !important;
    }
  }
  .ant-select-open {
    .ant-select-selector {
      box-shadow: none !important;
      border-color: ${(props) =>
        props.theme[props.brand].formSelect.singSelectBg} !important;
    }
  }
  .ant-select-focused {
    .ant-select-selector {
      box-shadow: none !important;
      border-color: ${(props) =>
        props.theme[props.brand].formSelect.addSingSelectBdNew} !important;
    }
  }
  .ant-select:focus {
    box-shadow: none !important;
  }
  .ant-select {
    font-size: 16px;
    .ant-select-selector {
      background: #fff !important;
      * {
        line-height: ${(props) => props.height} !important;
      }
    }
  }
  .ant-form-item-has-error
    .ant-select:not(.ant-select-borderless)
    .ant-select-selector {
    border-color: ${(props) =>
      props.theme[props.brand].formSelect.addSingSelectBdNew} !important;
  }
  .ant-form-item-control .ant-form-item-explain {
    color: ${(props) => props.theme[props.brand].formSelect.addSingSelectBdNew};
  }
  .ant-form-item-label > label.ant-form-item-required::before {
    color: ${(props) => props.theme[props.brand].formSelect.addSingSelectBdNew};
  }
  .ant-form-item-control .ant-select-arrow {
    top: 24px;
  }
  .sty16 {
    .ant-select-selection-item {
      font-size: 16px;
      color: #3a3a3a !important;
    }
    .ant-select-selection-placeholder {
      font-size: 16px;
      color: #424242;
    }
  }
`;
